import { Box } from "@mui/material";
import React from "react";
import CustomTable from "../../../components/CustomTable";
import DashboardTopTitle from "../../../components/DashboardTopTitle";
import { AddCircleOutline } from "@mui/icons-material";
import MessageTable from "../../../components/MessageTable";
import TableSearch from "../../../shared/TableSearch";
import TransactionTable from "../TransactionTable";

const Transactions = () => {
  return (
    <Box>
      <DashboardTopTitle
        title="Transaction Activities"
        onClickFirst={() => {}}
        secondBtnIcon={<AddCircleOutline />}
        secondBtnTitle="New Appointment"
        secondBtn
      />
      <TableSearch />
      <TransactionTable />
    </Box>
  );
};

export default Transactions;
